/**
 * @generated SignedSource<<d4b866ad65209c37987ab444a5d262b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarCreateQuery$variables = Record<PropertyKey, never>;
export type CalendarCreateQuery$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"CalendarAdminComponent_store">;
  };
};
export type CalendarCreateQuery = {
  response: CalendarCreateQuery$data;
  variables: CalendarCreateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarCreateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarAdminComponent_store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CalendarCreateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b44b2907612f5ccb4398923e17a959a3",
    "id": null,
    "metadata": {},
    "name": "CalendarCreateQuery",
    "operationKind": "query",
    "text": "query CalendarCreateQuery {\n  store {\n    ...CalendarAdminComponent_store\n    id\n  }\n}\n\nfragment CalendarAdminComponent_store on Store {\n  publicTeams {\n    ...TeamSelectList_Team\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n"
  }
};
})();

(node as any).hash = "10dadf3851a196147ad7f555f3c9547a";

export default node;
